import React, {useState} from "react";
import ContactFormModel from "./contact-form-model";

export default function LeadForm(props) {
    const [openModel, setOpenModel] = useState(true);
    
    return (
        <ContactFormModel show={props.openModel && openModel} onHide={() => setOpenModel(false)} />
    );
}